import { render, staticRenderFns } from "./DefaultRevisionForm.vue?vue&type=template&id=347596a2&"
import script from "./DefaultRevisionForm.vue?vue&type=script&lang=ts&"
export * from "./DefaultRevisionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports